// Generated for @nava/participant-copy: Clair's default texts in English. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in English. Written for Clair. */
export const PARTICIPANT_COPY_EN = {
    'landing.changeLanguage': 'Change language',
    'common.language': 'Language',
    'common.talkInLanguages': 'You can talk to Clair in more than 80 languages.',
    'common.seeLanguages': 'See which',
    'footer.poweredBy': 'Powered by',
    'landing.heading': 'You have been invited to a short conversation.',
    'landing.intro': '{company} would like to hear how things are going for you. You will talk with Clair, an AI assistant, whenever it suits you.',
    'landing.continue': 'Continue',
    'preflight.title': 'We just need a few things',
    'preflight.checkInSubtitle': 'Complete the checklist below to start the conversation.',
    'preflight.actions.expandItem': 'Expand {{item}}',
    'preflight.microphone.title': 'Microphone access',
    'preflight.microphone.checkInPrivacy': 'Your voice is used for the conversation with Clair, an AI assistant. It is recorded, transcribed and shared with {company}. All data is encrypted and stored securely.',
    'preflight.microphone.readMore': 'Read more',
    'preflight.microphone.grantAccess': 'Grant access',
    'preflight.microphone.indicatorAction': 'Grant microphone access',
    'preflight.microphone.accessGranted': 'Access granted',
    'preflight.microphone.errorHelper': 'Check your browser settings and try again.',
    'preflight.microphone.browserNotSupported': "Your browser doesn't support audio recording. Please use Chrome, Firefox, or Safari.",
    'preflight.terms.title': 'Privacy & consent',
    'preflight.terms.checkInPrivacy': 'This conversation is held by Clair, an AI assistant, on behalf of {company}. Your answers are shared with {company} and never used for advertising. You can stop at any time.',
    'preflight.terms.readMore': 'Read more',
    'preflight.terms.accept': 'Yes, I accept',
    'preflight.terms.indicatorAction': 'Accept privacy and consent',
    'preflight.terms.accepted': 'Accepted',
    'preflight.terms.rememberConsent': 'Remember my consent for 30 days',
    'preflight.terms.rememberConsentCallTooltip': 'Consent is saved only for this call, in this browser for 30 days.',
    'quickStart.agree': 'Agree',
    'quickStart.back': 'Back',
    'quickStart.cancel': 'Cancel',
    'preflight.startCheckIn': 'Start the conversation',
    'preflight.preparingCheckIn': 'Preparing the conversation...',
    'preflight.preparingCheckInDelayedTitle': 'Preparing the conversation.',
    'preflight.preparingCheckInDelayedSubtitle': 'Still working, please wait.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'This is taking longer than expected.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Please be patient.',
    'preflight.checkInPreparationFailedTitle': 'Could not prepare the conversation',
    'preflight.checkInPreparationFailedMessage': 'Some files for the conversation could not be loaded. Check your connection and try again.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Connecting',
    'interview.status.speaking': 'Speaking',
    'interview.status.listening': 'Listening',
    'interview.status.thinking': 'Thinking',
    'interview.question': 'Question {{current}} of {{total}}',
    'interview.mainQuestion': 'Main question {{current}} of {{total}}',
    'interview.recording': 'Your answer is being recorded...',
    'interview.endInterview': 'End conversation',
    'interview.muteTooltip': 'Mute microphone',
    'interview.unmuteTooltip': 'Unmute microphone',
    'interview.pauseTooltip': 'Take a break',
    'interview.resumeTooltip': 'Resume the conversation',
    'interview.subtitleTooltip.show': 'Show subtitles (CC)',
    'interview.subtitleTooltip.hide': 'Hide subtitles (CC)',
    'interview.toggleChat': 'Type instead',
    'interview.toggleVoice': 'Speak instead',
    'interview.chatTooltip.type': 'Type your answer instead',
    'interview.chatTooltip.speak': 'Speak your answer instead',
    'interview.chatTooltip.unavailable': 'Available once connected',
    'interview.chatDiscoveryHint': "Can't speak? Tap to type instead",
    'interview.chatPlaceholder': 'Type your message...',
    'interview.sendMessage': 'Send',
    'interview.chat.warmHeader': "Take your time, I'll wait while you type",
    'interview.chat.newlineHint': 'Shift + Enter for a new line',
    'interview.chat.aiVoiceOn': 'Voice on',
    'interview.chat.aiVoiceOff': 'Voice off',
    'interview.chat.backToVoice': 'Back to voice',
    'interview.audio.controls': 'Audio controls',
    'interview.audio.callVolume': 'Call volume',
    'interview.audio.muteSpeaker': 'Mute speaker',
    'interview.audio.unmuteSpeaker': 'Unmute speaker',
    'interview.audio.microphone': 'Microphone',
    'interview.audio.speaker': 'Speaker',
    'interview.audio.device': 'Audio device',
    'interview.audio.linkedRouting': 'Your phone controls the microphone and speaker together.',
    'interview.audio.phoneSpeaker': 'Phone speaker',
    'interview.audio.phoneEarpiece': 'Phone earpiece',
    'interview.audio.bluetoothHeadset': 'Bluetooth headset',
    'interview.audio.wiredHeadset': 'Wired headset',
    'interview.audio.usbAudio': 'USB audio',
    'interview.audio.systemDefault': 'System default',
    'interview.audio.changeFailed': 'Could not switch audio device.',
    'interview.networkQuality.excellent': 'Network quality is excellent.',
    'interview.networkQuality.good': 'Network quality is good.',
    'interview.networkQuality.poor': 'Network quality is poor.',
    'interview.networkQuality.bad': 'Network quality is bad.',
    'interview.networkQuality.offline': 'Connection is offline.',
    'interview.pauseModal.title': 'Conversation paused',
    'interview.pauseModal.timeRemaining': '{{time}} remaining',
    'interview.pauseModal.timeoutWarning': 'If you stay paused, the conversation will end on its own soon.',
    'interview.pauseModal.resume': 'Resume the conversation',
    'interview.pauseModal.end': 'End conversation',
    'interview.endConfirm.title': 'End the conversation?',
    'interview.endConfirm.body': "You won't be able to come back after ending. Your progress so far will be saved.",
    'interview.endConfirm.cancel': 'Continue the conversation',
    'interview.endConfirm.end': 'End conversation',
    'complete.checkInTitle': 'Thanks for your time',
    'complete.checkInMessage': 'Your answers go to the {company} team.',
    'studyClosed.checkInTitle': 'This conversation has closed',
    'studyClosed.checkInMessage': 'Thanks for your interest, it no longer takes answers.',
    'studyNotOpen.checkInTitle': 'This conversation is not open yet',
    'studyNotOpen.checkInMessage': 'Please try the link again later.',
    'studyNotReady.checkInTitle': 'This conversation is almost ready',
    'studyNotReady.checkInMessage': 'Please try the link again in a few minutes.',
    'participantLinkCompleted.checkInTitle': 'You have already had this conversation',
    'participantLinkCompleted.checkInMessage': 'Thanks for your time, there is nothing more you need to do.',
    'loading.interview': 'Loading the conversation...',
    'browserHelp.title': 'Use your browser',
    'browserHelp.description': 'This app’s browser may restrict microphone access. Open this link in {{browserOptions}} for the best experience.',
    'browserHelp.namedDescription': 'The browser inside {{app}} may restrict microphone access. Open this link in {{browserOptions}} for the best experience.',
    'browserHelp.appleBrowsers': 'Safari or Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge or Chrome',
    'browserHelp.otherBrowsers': 'Chrome or another browser',
    'browserHelp.openSafari': 'Open in Safari',
    'browserHelp.copyLink': 'Copy link',
    'browserHelp.copied': 'Link copied. Paste it into your browser.',
    'browserHelp.manualCopy': 'Could not copy automatically. Select and copy the link below.',
    'browserHelp.copyInstructions': 'Copy the link below and paste it into another browser. You can also check the app’s menu for an option to open this page in your default browser.',
    'browserHelp.linkLabel': 'Conversation link',
    'browserHelp.continueAnyway': 'Continue anyway',
    'preflight.microphone.recovery.denied': 'Microphone access denied.',
    'preflight.microphone.recovery.timedOut': 'The microphone request took too long. Check for a permission prompt in your browser, then try again.',
    'preflight.microphone.recovery.notFound': 'No microphone was found. Connect a microphone and try again.',
    'preflight.microphone.recovery.notReadable': 'Your microphone could not be opened. Close other apps using it and try again.',
    'preflight.microphone.recovery.failed': 'We could not access your microphone. Check your microphone and try again.',
    'preflight.microphone.recovery.retry': 'Try again',
    'preflight.microphone.recovery.close': 'Close',
    'preflight.microphone.recovery.helpTitle': 'Allow microphone access',
    'preflight.microphone.recovery.helpDescription': 'Microphone access is still blocked. Your browser may remember your earlier choice and skip the permission prompt.',
    'preflight.microphone.recovery.safariMacSettings': 'In Safari’s menu bar, choose Safari > Settings > Websites > Microphone. Find this website in the list.',
    'preflight.microphone.recovery.chromiumSettings': 'Click the site controls icon to the left of the address bar, then Site settings > Microphone.',
    'preflight.microphone.recovery.siteSettings': 'Open this website’s permissions in your browser, using the icon or menu beside the address bar or the browser’s site settings.',
    'preflight.microphone.recovery.allowMicrophone': 'Allow microphone access for this website, then return here and select “Try again”. If the browser asks you to reload, reload this page.',
    'preflight.microphone.recovery.deviceSettings': 'If access is already allowed, check that your device settings allow this browser to use the microphone.',
    'microphoneQuality.title': 'Microphone quality',
    'microphoneQuality.instructions': 'Start speaking for a few seconds so we can check how well we can hear you.',
    'microphoneQuality.recoveryMessage': 'We can’t hear you. If you’re on a call, end it first. Close other apps using your microphone, then try again.',
    'microphoneQuality.poor': 'Poor',
    'microphoneQuality.almostThere': 'Almost there',
    'microphoneQuality.perfect': 'Perfect!',
    'microphoneQuality.waiting': 'Waiting for audio...',
    'microphoneQuality.from': 'From',
    'microphoneQuality.defaultDevice': 'Default Microphone',
    'microphoneQuality.helpText': 'Please speak louder or move closer to your microphone',
    'microphoneQuality.done': 'Done',
    'startupRecovery.title': 'The conversation could not start',
    'startupRecovery.failed': "We couldn't connect to the conversation service. Please try again.",
    'startupRecovery.timedOut': 'Connecting took too long. Please try again.',
    'startupRecovery.cancelled': "The connection was cancelled. You can try again when you're ready.",
    'startupRecovery.microphone': "We couldn't access your microphone. Check its permissions and try again.",
    'startupRecovery.delayed': 'Still connecting. This is taking longer than usual…',
    'startupRecovery.retry': 'Try again',
    'startupRecovery.support': 'Support reference',
    'startupRecovery.copy': 'Copy reference',
    'startupRecovery.copied': 'Copied',
    'startupRecovery.checking': 'Checking connection…',
    'startupRecovery.unavailable': 'Could not verify',
    'startupRecovery.advice': 'This check only tests reachability. You can still try starting. If it fails, try another browser or network.',
    'startupRecovery.checkAgain': 'Re-check connection...',
    'connectionDetails.quality': 'Network quality',
    'connectionDetails.excellent': 'Excellent',
    'connectionDetails.good': 'Good',
    'connectionDetails.poor': 'Poor',
    'connectionDetails.bad': 'Bad',
    'connectionDetails.offline': 'Offline',
    'connectionDetails.notChecked': 'Not checked',
    'connectionDetails.lastChecked': 'Last checked',
    'connectionDetails.warning': 'Could not verify the connection {{services}}',
    'connectionDetails.navaApi': 'Clair API',
    'connectionDetails.interviewApi': 'Clair conversation service',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Refresh connection test',
    'connectionDetails.success': 'Connection check passed.',
    'connection.error': 'Connection error',
    'connection.errorDefault': 'Failed to connect to the conversation service',
    'connection.retry': 'Retry',
    'versionRefresh.message': "A new version is available. Refresh your browser when you're ready.",
    'versionRefresh.action': 'Refresh',
    'cookies.banner.title': 'We value your privacy',
    'cookies.banner.message': 'We use cookies to optimize your experience, understand product usage, and support relevant marketing. Choose <bold>“Accept all”</bold> to consent to all cookies, or <bold>“Manage preferences”</bold> to adjust your settings.',
    'cookies.banner.privacyPolicy': 'Privacy Policy',
    'cookies.banner.acceptAll': 'Accept all',
    'cookies.banner.managePreferences': 'Manage preferences',
    'cookies.modal.title': 'Cookie settings',
    'cookies.modal.description': 'When you visit Clair, we may store or retrieve data about you using cookies and similar technologies. Essential cookies keep the website functioning. You can update optional preferences at any time.',
    'cookies.modal.readMore': 'Read more in our',
    'cookies.modal.save': 'Save',
    'cookies.modal.close': 'Close cookie preferences',
    'cookies.modal.essential.title': 'Essential',
    'cookies.modal.essential.description': 'Required for basic website functionality. Essential cookies cannot be disabled.',
    'cookies.modal.analytics.title': 'Analytics',
    'cookies.modal.analytics.description': 'Helps Clair understand how the website performs, how visitors interact with it, and whether there may be technical issues.',
    'invitation.subject': 'A short conversation with {company}',
    'invitation.greeting': 'Hi {name},',
    'invitation.body': 'We would like to hear how things are going for you.',
    'invitation.aiNotice': 'You will talk with Clair, our AI assistant. Most people find it easier to be honest with an AI than with a person, and you can do it whenever it suits you, at work or at home.',
    'invitation.button': 'Start the conversation',
    'invitation.fallbackLink': 'Or paste this into your browser:',
    'invitation.footer': 'You are receiving this because you are a customer of {company}. The conversation is held by Clair, an AI assistant, on their behalf.',
    'invitation.optOut': 'Do not send me these again',
    'sms.invite': '{company} invites you to a short conversation:',
    'sms.stop': 'Stop SMS:',
};
//# sourceMappingURL=en.js.map